import { AdminLayout } from '@/app/components/AdminLayout';

interface PageLoadingProps {
  message?: string;
}

export function PageLoading({ message = 'Carregando...' }: PageLoadingProps) {
  return (
    <AdminLayout>
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-500">{message}</p>
      </div>
    </AdminLayout>
  );
}
